import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GenericService } from '../../generic.service';
import { MachineTypes, machineModels } from '../../../assets/data/deviceData';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LandingService } from '../../landing-page/service/landing.service';
import { ApiComponentServices } from '../../services/api-services';
import { Subscription } from 'rxjs';
import { defaultLanguage } from '../../shared/constants/language.constants';
import { CrowdinService } from '../../shared/service/crowdin.service';

@Component({
  selector: 'app-support',
  imports: [CommonModule, FormsModule],
  templateUrl: './support.component.html',
  styleUrl: './support.component.scss'
})
export class SupportComponent {
  request: string = 'close';
  deviceData: any = {};
  deviceData$: any = null;
  machineTypes: any = MachineTypes;
  machineModels: any = machineModels;
  machineModel: any = '';
  accountNumber: any = '';
  accountName: any = '';
  city: any = '';
  state: any = '';
  zip: any = '';
  isBusinessHours: boolean = false;
  isLoading: boolean = true;
  dishMachineDetail: any;
  devices: any[] = [];
  selectedDevice: any = null;
  machineImageUrl: string = '';
  translations: { [key: string]: string } = {};
  currentLanguage: string = defaultLanguage;
  languageOptions: Array<{ value: string }> = [];
  isLoadingTranslations = true;
  subs = new Subscription();

  constructor(
    private router: Router,
    private genericService: GenericService,
    private route: ActivatedRoute,
    private landingService: LandingService,
    private apiService: ApiComponentServices,
    private crowdinService: CrowdinService,
  ) {
    this.deviceData = this.genericService.getLocalStorage();
    this.route.paramMap.subscribe((params) => {
      this.updateStateAndZipFromParams(params);
    });
  }

  ngOnInit() {
    this.languageOptions = this.landingService.getLanguageOptions();

    const stored = localStorage.getItem('deviceData');
    const selectedName = stored
      ? JSON.parse(stored).languageSelected || defaultLanguage
      : defaultLanguage;
    this.currentLanguage = selectedName;

    this.subs.add(
      this.landingService.languageName$.subscribe((langName) => {
        this.currentLanguage = langName;
        this.translations = this.crowdinService.getAllTranslations();
      }),
    );

    const languageCodeParam =
      this.route.snapshot.queryParamMap.get('languageCode');
    if (languageCodeParam) {
      this.currentLanguage = languageCodeParam;
      this.landingService.loadTranslations(languageCodeParam);
    } else {
      this.landingService.loadTranslations(this.currentLanguage);
    }

    this.loadAccountDetailsDirectly();
    this.machineModel = this.getModel() || '';
    this.loadMachineImage();
    this.isBusinessHours = this.isCurrentTimeWithinBusinessHours();
  }

  async languageChange(event: any) {
    const selectedLang = event.target.value;
    await this.landingService.loadTranslations(selectedLang);
  }

  getModel(): string | null {
    return this.landingService.setSelectedDevice('model');
  }

  updateStateAndZipFromParams(params: any) {
    this.deviceData = this.genericService.syncLocationFromQueryParams(
      this.route.snapshot.queryParamMap,
      this.deviceData,
    );

    this.state = this.deviceData?.state || '';
    this.zip = this.deviceData?.zip || '';
    this.deviceData.accountKey = this.getAccountKey();
    this.deviceData.accountName = this.getAccountName();
    this.deviceData.selectedMachineType = this.getModel();
    this.deviceData.AccountNumber = params.get('accountNumber') || '';
    this.genericService.setLocalStorage(this.deviceData);
  }

  loadAccountDetailsDirectly(): void {
    this.apiService
      .getAccountData(
        this.deviceData.AccountNumber,
        '',
        this.deviceData.accountKey,
        true
      )
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.deviceData = {
              ...this.deviceData,

              accountName: res.AccountName ?? this.deviceData.accountName,
              state: res.State ?? this.deviceData.state,
              zip: res.ZipCode ?? this.deviceData.zip,
              accountNumber: res.AccountNumber ?? this.deviceData.accountNumber,

              CountryIso3Code: res.CountryIso3Code,
              Status: res.Status
            };

            this.devices = res.Devices || [];

            this.deviceData.languageSelected = this.currentLanguage;

            this.genericService.setLocalStorage(this.deviceData);

            this.landingService.loadTranslations(this.currentLanguage);
          }

          this.isLoading = false;
        },

        error: (error) => {
          console.error(
            'Failed to retrieve account details',
            error
          );

          this.dishMachineDetail = null;
          this.devices = [];

          this.isLoading = false;
        }
      });
  }

  loadMachineImage() {
    if (!this.machineModel) {
      this.machineImageUrl = '';
      return;
    }
    this.landingService
      .getDeviceImageByModelFromModelName(this.machineModel)
      .subscribe((imgUrl) => {
        this.machineImageUrl = imgUrl;
      });
  }

  get isMachineSelected(): boolean {
    return !!this.deviceData?.selectedMachineType;
  }

  ngAfterViewInit() {
    this.addCustomFeild();
  }

  navigate(pageNme: any) {
    this.deviceData['languageSelected'] = this.currentLanguage;
    this.genericService.setLocalStorage(this.deviceData);
    this.genericService.deviceData.next(this.deviceData);
    if (pageNme === 'edit') this.router.navigate(['/esrEdit']);
    else if (pageNme === 'contact-us') this.router.navigate(['/contact-us']);
    else this.router.navigate(['/esrSupportDetails']);
  }

  // getModelName() {
  //   let productLine, model: any;
  //   this.machineTypes.forEach((element: any) => {
  //     if (element.setValue == this.deviceData?.productLine)
  //       productLine = element.value[this.languageIndex];
  //   });
  //   return productLine + ', ' + this.deviceData.model;
  // }

  addCustomFeild() {
    // Prepare custom data for chat initialization
    const customData = {
      accountNumber: this.accountNumber,
      accountName: this.accountName,
      machineModel: this.machineModel,
      state: this.state,
      zip: this.zip,
    };

    // Get country code from route or stored data
    const countryCode = this.getCountryCode() || this.deviceData?.countryCode;

    // Initialize chat with custom fields using the reusable service method
    this.landingService.initializeChatCustomFields(customData, countryCode);
  }

  niceChat() {
    const element = document.querySelector(
      '[data-selector=GUIDE_CHANNEL_BUTTON]',
    ) as HTMLElement;

    element.style.visibility = 'visible';
    if (element) {
      element.click();
    }

    setTimeout(() => {
      const minimizeButton: any = document.querySelector(
        "[data-cy='header-minimize-window']",
      );

      minimizeButton.addEventListener('click', function () {
        // Your action for minimizing the window
        // You can put more logic here to minimize the window
      });
    }, 4000);
  }

  getState(): string | null {
    return this.route.snapshot.queryParamMap.get('state');
  }

  getPostalCode(): string | null {
    return this.route.snapshot.queryParamMap.get('postalCode');
  }

  getCountryCode(): string | null {
    return this.route.snapshot.queryParamMap.get('countryCode');
  }

  getAccountKey(): string | null {
    return this.landingService.getAccountKey();
  }

  getAccountName(): string | null {
    return this.landingService.getAccountName();
  }

  changeDevice() {
    const accountNumber = this.deviceData?.AccountNumber || this.accountNumber;
    const modelValue = this.getModel();

    this.deviceData['languageSelected'] = this.currentLanguage;
    this.genericService.setLocalStorage(this.deviceData);
    this.genericService.deviceData.next(this.deviceData);

    this.router
      .navigate(['/devices', accountNumber], {
        queryParams: {
          model: modelValue,
        },
      })
      .then(() => {
        window.location.reload();
      });
  }

  isCurrentTimeWithinBusinessHours(): boolean {
    const currentTime = new Date();
    const currentDay = currentTime.getUTCDay(); // 0 (Sunday) to 6 (Saturday)
    const currentHour = currentTime.getUTCHours();
    const currentMinute = currentTime.getUTCMinutes();

    const isDST = (date: Date) => {
      const year = date.getUTCFullYear();
      const startDST = new Date(Date.UTC(year, 2, 8)); // 2nd Sunday of March
      const endDST = new Date(Date.UTC(year, 10, 1)); // November 1st

      // Move startDST to the second Sunday of March
      startDST.setUTCDate(8 + ((7 - startDST.getUTCDay()) % 7));

      return date >= startDST && date < endDST;
    };

    const isInDST = isDST(currentTime);

    // Central Time offset: -6 during DST, -5 during Standard Time
    const offset = isInDST ? -5 : -6;

    // Convert current time to Central Time (CT) using the offset
    let currentCTHour = currentHour + offset;

    // Adjust if hour is outside the 24-hour range
    if (currentCTHour < 0) currentCTHour += 24;
    if (currentCTHour >= 24) currentCTHour -= 24;

    // Check if the current day is Monday to Friday
    const isWeekday = currentDay >= 1 && currentDay <= 5;

    // Business hours:
    // - DST: 7 AM to 3:30 PM (CDT)
    // - Standard: 8 AM to 4:30 PM (CST)
    const isWithinBusinessHours = isInDST
      ? (currentCTHour > 8 || (currentCTHour === 8 && currentMinute >= 0)) &&
      (currentCTHour < 16 || (currentCTHour === 16 && currentMinute <= 30))
      : (currentCTHour > 7 || (currentCTHour === 7 && currentMinute >= 0)) &&
      (currentCTHour < 15 || (currentCTHour === 15 && currentMinute <= 30));

    return isWeekday && isWithinBusinessHours;
  }
}
